import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FFCDLogbookEntry } from 'ff/debrief/models';
import { LogbookEntry } from 'shared/sharedTypes/logbook/LogbookEntryModels';

const LogbookEntryDetails = ({
    logbookEntry,
    isAssociated,
}: {
    logbookEntry: FFCDLogbookEntry | LogbookEntry;
    isAssociated: boolean;
}) => {
    const getTailNumber = (entry: FFCDLogbookEntry | LogbookEntry): string => {
        if ('aircraftId' in entry) {
            return (entry as { aircraftId: string }).aircraftId;
        } else if ('aircraft' in entry && entry.aircraft?.tailNumber) {
            return entry.aircraft.tailNumber;
        }
        return 'N/A';
    };

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography
                component="div"
                color="#526f8a"
                sx={{ fontSize: '13px', marginRight: '10px' }}
            >
                {getTailNumber(logbookEntry)}
            </Typography>
            <Typography
                component="span"
                sx={{
                    flexShrink: 0,
                    marginRight: '10px',
                    color: isAssociated ? '#4BB543' : '#ff6e6e',
                    fontWeight: '900',
                    transition: 'opacity 2s ease-in-out',
                }}
            >
                {isAssociated ? 'Connected' : 'Not Connected'}
            </Typography>
        </Box>
    );
};

export default LogbookEntryDetails;
